import { Column, Row } from "@tanstack/react-table";
import { ModelScreenerRow } from "@models/model-screener/entities/modelScreenerData";
import React, { useMemo } from "react";
import { MSTableStickyConstants } from "@pages/managed-accounts/model-screener/constant";
import { MSTableStickyCell } from "@pages/managed-accounts/model-screener/components/model-screener-table/table/table-sticky-cell";

type MSTableStickyColumnProps = {
  row: Row<ModelScreenerRow>;
  columns: Column<ModelScreenerRow>[];
};

export const MSTableStickyColumn = React.memo(
  ({ row, columns }: MSTableStickyColumnProps) => {
    const visibleCells = row.getVisibleCells();

    const stickyColumns = useMemo(
      () => columns?.slice(0, MSTableStickyConstants.LastBodyColumnIndex + 1),
      [columns],
    );

    const cells = useMemo(
      () =>
        stickyColumns?.map((_, index) => (
          <MSTableStickyCell
            key={`sticky-${row.original.id}-${index}`}
            cell={visibleCells[index]}
          />
        )),
      [stickyColumns, visibleCells, row.original.id],
    );

    return <>{cells}</>;
  },
);
